<template>
	<!-- class="bg-grey-1" -->
	<q-layout view="lHr LpR lFr" v-if="app_state().ready">

		<HeaderAuth />

		<!-- <MessageNewAppli v-if="pp.showMessageNewAppli" /> -->

		<!-- <div class="col-sm-12 col-md-8 offset-md-2 q-my-md text-center text-body1"> -->
		<!-- <div class="col-12"> -->
		<q-img class="bg-logo"
			    :src="utils?.infos.logo" :alt="app_state().app_name" key="logo" />
			    <!-- :src="utils?.infos['logo-big-url-' + ($q.dark.isActive ? 'white' : 'black')]" :alt="app_state().app_name" key="logo" /> -->
		<!-- </div> -->

		<q-page-container>
			<MyAlert
				v-if="pp.users_disconnected_by_webmaster"
				class="q-pt-md"
				:action="() => refresh()"
				label-action="Rechargez la page"
				icon-action="refresh"
			>
				<b
					>Vous avez été déconnecté pour cause de maintenance / mise à
					jour...</b
				>
				(le {{ formatDate({ withHour: true }) }}) <br />Ceci pour éviter
				tout problème de requêtes en Base de Données.
				<br />Rassurez-vous, cela ne devrait pas durer longtemps.
				<br />Merci de votre compréhension. <br /><br /><span
					class="text-caption"
					>Rechargez juste la page de temps en temps pour voir si le
					formulaire de connexion est accessible.</span
				>
			</MyAlert>
			<!-- {{log(pp['admin_has_disconnected_user_ip_'+pp?.id], pp?.id, pp)}} -->
			<!-- admin_has_disconnected_user_ip_127-0-0-1 -->
			<!-- <MyAlert v-if="pp['admin_has_disconnected_user_ip_'+pp?.id]">
            Vous avez été déconnecté par un Administrateur...
        </MyAlert> -->

			<q-page padding>
				<!-- <div class="text-center text-white q-px-sm q-py-lg shadow-10 row full-width q-mb-lg bg-circle-green">
                <div class="col-sm-2 col-md-1">
                    <q-icon name="thumb_up" size="5rem" class="q-pb-xs q-ml-sm" />
                </div>
                <div class="col-sm-10 col-md-11">
                    <div v-dompurify-html="texts.text_1"></div>
                </div>
            </div> -->

				<transition appear name="fade" mode="out-in">

					<main v-if="app_state().show_page" class="auth-main row q-pb-xl">

	                    <div class="col-12 row flex-center q-mb-md">
                            <!-- <q-img class="q-mt--md" :src="$q.dark.isActive ? utils?.infos.logo_white : utils?.infos.logo" v-gsinit:slide-up -->
                            <q-img class="q-mt--md" :src="$q.dark.isActive ? '/images/logo-white-for-auth-pages.png' : '/images/logo-for-auth-pages.png'" v-gsinit:slide-up
                                    width="140px" :alt="app_state().app_name" />
                        </div>




						<slot></slot>
						<!-- <q-btn label="plus d'infos sur notre site internet" @click="open(utils.infos.site_url, utils.infos.societe)" icon-right="open_in_new" rel="noreferer noopener"
                            class="full-width q-mt-lg" stretch color="secondary" size="xl" /> -->
					</main>
				</transition>

				<!-- <MyAlert size="lg" type="primary" class="col-12 q-mt-lg"
                    :action="()=>{ open(utils.infos.site_url, utils.infos.societe) }"
                    label-action="plus d'infos sur notre site"
                    icon-action="open_in_new"
                    color-action="secondary">
                <p class="text-h4 text-center q-pt-md" v-dompurify-html="texts.price"></p>
            </MyAlert>


            <div class="div-text-bg-white full-width col-sm-12 col-md-8 offset-md-2 q-mb-lg q-pa-md text-center" style="margin-top:-5px">

                <div v-dompurify-html="texts.text_2"></div>
            </div> -->

				<!-- <TermsAndPolicyButtons classes="bottom-left" flat size="sm" color="grey-8" /> -->

				<q-page-scroller
					position="bottom-right"
					:scroll-offset="150"
					:offset="[10, 10]"
				>
					<q-btn
						:size="$_isMobile ? 'sm' : 'md'"
						icon="keyboard_arrow_up"
						class="q-animate--scale q-pa-xs"
						round
						color="secondary"
						text-color="white"
					/>
				</q-page-scroller>
			</q-page>

            <!-- <Flash /> -->

		</q-page-container>
	</q-layout>
</template>

<script setup>
import { app_state, refresh, formatDate } from "@helpers";
// import { appStore } from '@stores'

// const appStore =  proto.$pinia.state.value.appStore

// log('in Auth Layout',
//     app_state(),
//     proto.$pinia,
//     // appStore,
// )
</script>
